export default "__VITE_ASSET__B8SH$LGJ__"